import Notifications from "../../../jsx/components/Dashboard/Notifications/notifications";

const NotificationsWrapper = () => {
  return <Notifications />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(NotificationsWrapper);
